<template>
    <div class="loading-content">
      <img src="../assets/loading.gif" alt="">
    </div>
</template>

<script>
    export default {
        name: "loading"
    }
</script>

<style scoped>
.loading-content{
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/loading.vue